import { Box, Flex, Text } from '@mantine/core';
import IconNetworkError from '@/shared/uikit/assets/icons/IconNetworkError.svg?react';

export const NetworkError = () => (
	<Flex
		direction="column"
		align="center"
		justify="center"
		h={'calc(100vh - 220px)'}
	>
		<Box pb={20}>
			<IconNetworkError fontSize={71} color="rgba(47, 158, 81, 1)" />
		</Box>
		<Text fz={18} fw={700}>
			Упс, что-то пошло не так
		</Text>
	</Flex>
);
